import { decode } from 'html-entities';

const decodeEntities = (html: string): string => {
    return decode(html);
};

export default decodeEntities;
